// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ok_a bhf_qr bhf_a bhf_w","FaqAskQuestion__outdated":"ok_b bhf_vp bhf_xe"};